import React from 'react';

import { Flex, Loader, Text, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function SavingIndicator() {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Flex
      align="center"
      justify="center"
      sx={(theme) => ({
        gap: '8px',
        padding: '6px',
        color: theme.colors.gray[6]
      })}>
      <Flex align="center" gap={8}>
        <Loader size="xs" color={theme.colors.gray[6]} />
        <Text size="sm" fw={500} sx={{ userSelect: 'none' }}>
          {t('SMART_EDITOR.SAVING')}
        </Text>
      </Flex>
    </Flex>
  );
}
